<template>
    <modal class="min-h-full" :open="open" @close="$emit('close')">
        <h1
            class="mb-2 flex flex-row flex-wrap content-center items-center border-b border-slate-500 pb-1 text-lg text-sm font-bold text-gray-900 dark:text-white"
        >
            Enviar Notificação
        </h1>

        <form @submit.prevent="submit">
            <div class="mt-5 flex-col sm:mt-4 sm:flex">
                <div class="mb-3 grid gap-2 sm:grid-cols-1">
                    <div>
                        <label class="text-sm text-gray-900 dark:text-white"> Título </label>
                        <input
                            type="text"
                            id="title"
                            v-model="form.title"
                            name="title"
                            class="text-input"
                            placeholder="Título"
                            required
                        />
                    </div>
                    <div>
                        <label class="text-gray-900 dark:text-white"> Descrição </label>
                        <input
                            type="text"
                            id="body"
                            v-model="form.body"
                            minlength="10"
                            name="body"
                            class="text-input"
                            placeholder="Descrição"
                            required
                        />
                    </div>

                    <div>
                        <label class="text-gray-900 dark:text-white"> Link </label>
                        <input
                            v-model="form.link"
                            type="url"
                            id="link"
                            name="link"
                            class="text-input"
                            placeholder="Link"
                        />
                    </div>

                    <div>
                        <label class="text-gray-900 dark:text-white"> Som da Notificação </label>
                        <select
                            v-model="form.sound"
                            class="text-input"
                        >
                            <option value="1">Cash is King</option>
                            <option value="2">Mario Bros</option>
                            <option value="3">Street Fighter</option>
                        </select>
                    </div>

                    <div>
                        <label class="text-gray-900 dark:text-white"> Tópicos </label>
                        <div class="grid grid-cols-2 gap-3 dark:text-white">
                            <div class="flex flex-row gap-2">
                                <label for="ios">iOS (Produção)</label>
                                <input
                                    type="checkbox"
                                    id="ios"
                                    name="topics"
                                    value="ios"
                                    v-model="form.topics"
                                />
                            </div>
                            <div class="flex flex-row gap-2">
                                <label for="android">Android (Produção)</label>
                                <input
                                    type="checkbox"
                                    id="android"
                                    name="topics"
                                    value="android"
                                    v-model="form.topics"
                                />
                            </div>
                            <div class="flex flex-row gap-2">
                                <label for="iosTest2025" class="text-yellow-400">iOS Teste</label>
                                <input
                                    type="checkbox"
                                    id="iosTest2025"
                                    name="topics"
                                    value="iosTest2025"
                                    v-model="form.topics"
                                />
                            </div>
                            <div class="flex flex-row gap-2">
                                <label for="androidTest2025" class="text-yellow-400">Android Teste</label>
                                <input
                                    type="checkbox"
                                    id="androidTest2025"
                                    name="topics"
                                    value="androidTest2025"
                                    v-model="form.topics"
                                />
                            </div>
                        </div>
                    </div>

                    <submit-button :loading="loading"> Enviar </submit-button>
                </div>
            </div>
        </form>
    </modal>
</template>

<script>
import Modal from "../../components/layouts/Modal.vue";
import SubmitButton from "../../components/forms/SubmitButton.vue";
import { useToast } from "vue-toastification";

export default {
    props: ["open"],
    components: { SubmitButton, Modal },
    emits: ["close", "fetch"],
    setup() {
        const toast = useToast();
        return { toast };
    },
    data() {
        return {
            loading: false,
            form: {
                body: null,
                title: null,
                link: null,
                sound: 1,
                topics: [],
            },
        };
    },
    methods: {
        submit() {
            this.loading = true;
            axios
                .post("/api/mobile-devices/send-many", this.form)
                .then(({ data }) => {
                    this.loading = false;
                    this.toast.success("Notificação enviada com sucesso.");
                    this.$emit("fetch");
                });
        },
    },
};
</script>
